/*!
 * LorenZone — Ma Collection V2 : moteur partagé (window.LZMC)
 * ---------------------------------------------------------------------------
 * Utilisé par le tableau de bord (/pages/ma-collection), la barre de vente des
 * pages de série et le widget des fiches cartes.
 *
 *  - LZMC.series(handle)        données d'une série (section lz-mc-data, mise en cache)
 *  - LZMC.missing(series, own)  cartes manquantes, en stock, prix pour compléter
 *  - LZMC.addToCart(items, src) ajout groupé au panier (lots de 25), attribution
 *                               « _lz_src » invisible pour le client, tiroir panier
 *  - LZMC.local                 collection locale d'un visiteur non connecté
 *  - LZMC.money(cents)          « 1,50 € »
 *  - LZMC.track(name, data)     mesure (si connecté)
 */
(function () {
  if (window.LZMC) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CACHE_TTL_MS = 10 * 60 * 1000;
  var CART_MAX_LINES = 500;
  var mem = {};

  // ---------------------------------------------------------------------------
  // Formatage
  // ---------------------------------------------------------------------------
  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    return v.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function esc(s) {
    return (s == null ? '' : String(s))
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function plural(n, one, many) { return n + ' ' + (n > 1 ? many : one); }

  // ---------------------------------------------------------------------------
  // Données de série (Section Rendering API → sections/lz-mc-data.liquid)
  // ---------------------------------------------------------------------------
  function parseDataHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector('script.lz-mc-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function normalizeSeries(pages) {
    var first = pages[0];
    var cards = [];
    pages.forEach(function (pg) {
      (pg.c || []).forEach(function (row) {
        cards.push({
          pid: String(row[0]), code: row[1] || '', name: row[2] || '', img: row[3] || '',
          rar: row[4] || '', url: row[5] || '',
          variants: (row[6] || []).map(function (v) {
            return { vid: String(v[0]), kind: v[1], title: v[2], price: Number(v[3]) || 0, buy: v[4] === 1 };
          }),
        });
      });
    });
    return { u: first.u, h: first.h, t: first.t, n: first.n, logo: first.logo, cards: cards };
  }

  function cacheGet(handle) {
    var m = mem[handle];
    if (m && Date.now() - m.at < CACHE_TTL_MS) return m.data;
    try {
      var raw = sessionStorage.getItem('lzmc:s:' + handle);
      if (raw) {
        var o = JSON.parse(raw);
        if (Date.now() - o.at < CACHE_TTL_MS) { mem[handle] = o; return o.data; }
      }
    } catch (e) {}
    return null;
  }
  function cacheSet(handle, data) {
    var o = { at: Date.now(), data: data };
    mem[handle] = o;
    try { sessionStorage.setItem('lzmc:s:' + handle, JSON.stringify(o)); } catch (e) { /* quota : la mémoire suffit */ }
  }
  function cacheDrop(handle) {
    delete mem[handle];
    try { sessionStorage.removeItem('lzmc:s:' + handle); } catch (e) {}
  }

  // Débit : au plus 3 pages de série chargées en même temps (un tableau de bord qui
  // suit 20 séries ne déclenche pas la limite de Shopify) ; une réponse 429
  // (« trop de requêtes ») est rejouée après une pause, deux fois au plus.
  var queue = [], active = 0, MAX_ACTIVE = 3;
  function pause(ms) { return new Promise(function (res) { setTimeout(res, ms); }); }
  function limited(fn) {
    return new Promise(function (resolve, reject) {
      queue.push({ fn: fn, resolve: resolve, reject: reject });
      drain();
    });
  }
  function drain() {
    while (active < MAX_ACTIVE && queue.length) {
      var job = queue.shift();
      active++;
      Promise.resolve().then(job.fn).then(job.resolve, job.reject).then(function () { active--; drain(); });
    }
  }
  function fetchText(url, tries) {
    tries = tries || 0;
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (r.status === 429 && tries < 2) {
        var ra = r.headers && r.headers.get ? Number(r.headers.get('Retry-After')) || 0 : 0;
        return pause(Math.min(ra ? ra * 1000 : 1500 * (tries + 1), 8000)).then(function () { return fetchText(url, tries + 1); });
      }
      if (!r.ok) throw new Error('http_' + r.status);
      return r.text();
    });
  }

  var inflight = {};
  /** Charge toutes les pages d'une série. Rejette si la série est introuvable. */
  function series(handle, opts) {
    opts = opts || {};
    if (!handle) return Promise.reject(new Error('no_handle'));
    if (!opts.fresh) {
      var c = cacheGet(handle);
      if (c) return Promise.resolve(c);
    }
    if (inflight[handle]) return inflight[handle];
    var base = ROOT + 'collections/' + encodeURIComponent(handle);
    function page(n) {
      return limited(function () { return fetchText(base + '?section_id=lz-mc-data' + (n > 1 ? '&page=' + n : '')); })
        .then(function (html) {
          var d = parseDataHtml(html);
          if (!d || d.error) throw new Error((d && d.error) || 'no_data');
          return d;
        });
    }
    inflight[handle] = page(1)
      .then(function (p1) {
        var n = Math.min(Number(p1.pp) || 1, 8);
        var rest = [];
        for (var i = 2; i <= n; i++) rest.push(page(i));
        return Promise.all(rest).then(function (others) { return [p1].concat(others); });
      })
      .then(function (pages) {
        var s = normalizeSeries(pages);
        cacheSet(handle, s);
        return s;
      })
      .finally(function () { delete inflight[handle]; });
    return inflight[handle];
  }

  // ---------------------------------------------------------------------------
  // Calcul des manquantes
  // ---------------------------------------------------------------------------
  /** Variante « principale » d'une carte : même règle que les traqueurs (1re non-reverse). */
  function primaryVariant(card) {
    for (var i = 0; i < card.variants.length; i++) if (card.variants[i].kind !== 'reverse') return card.variants[i];
    return card.variants[0] || null;
  }
  function reverseVariant(card) {
    for (var i = 0; i < card.variants.length; i++) if (card.variants[i].kind === 'reverse') return card.variants[i];
    return null;
  }

  /**
   * own = { products: Set|Array, variants: Set|Array }
   * Renvoie la progression et les cartes manquantes achetables, triées du moins
   * cher au plus cher (le plus facile à compléter d'abord).
   */
  function missing(s, own) {
    var P = own && own.products instanceof Set ? own.products : new Set((own && own.products) || []);
    var V = own && own.variants instanceof Set ? own.variants : new Set((own && own.variants) || []);
    var res = {
      total: s.cards.length, owned: 0,
      missing: [], buyable: [], buyableCents: 0,
      rev: { total: 0, owned: 0, buyable: [], buyableCents: 0 },
      ownedValueCents: 0,
    };
    s.cards.forEach(function (card) {
      var pv = primaryVariant(card);
      var isOwned = P.has(card.pid);
      if (isOwned) {
        res.owned++;
        if (pv) res.ownedValueCents += pv.price;
      } else {
        res.missing.push(card);
        // Achetable : la variante principale, sinon une autre version non-reverse disponible.
        var buyV = pv && pv.buy ? pv : null;
        if (!buyV) {
          for (var i = 0; i < card.variants.length; i++) {
            var v = card.variants[i];
            if (v.kind !== 'reverse' && v.buy) { buyV = v; break; }
          }
        }
        if (buyV) { res.buyable.push({ card: card, variant: buyV }); res.buyableCents += buyV.price; }
      }
      var rv = reverseVariant(card);
      if (rv) {
        res.rev.total++;
        if (V.has(rv.vid)) res.rev.owned++;
        else if (rv.buy) { res.rev.buyable.push({ card: card, variant: rv }); res.rev.buyableCents += rv.price; }
      }
    });
    res.buyable.sort(function (a, b) { return a.variant.price - b.variant.price; });
    res.rev.buyable.sort(function (a, b) { return a.variant.price - b.variant.price; });
    res.pct = res.total ? Math.round((res.owned / res.total) * 100) : 0;
    return res;
  }

  // ---------------------------------------------------------------------------
  // Panier
  // ---------------------------------------------------------------------------
  function postAdd(items, tries) {
    tries = tries || 0;
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
      credentials: 'same-origin',
    }).then(function (r) {
      if (r.status === 429 && tries < 2) return pause(1500 * (tries + 1)).then(function () { return postAdd(items, tries + 1); });
      return r.json().catch(function () { return {}; }).then(function (b) { return { ok: r.ok, status: r.status, body: b }; });
    });
  }

  /**
   * Retour visuel après un ajout, avec les composants du thème Dawn :
   *  - tiroir panier (<cart-drawer>) si le thème est en mode « tiroir » ;
   *  - sinon la notification « Ajouté au panier → Voir le panier / Paiement »
   *    (<cart-notification>, mode actuel de LorenZone) ;
   *  - dans tous les cas, la pastille du panier est re-rendue par le serveur (elle
   *    n'existe pas quand le panier était vide : la réécrire en JS ne suffisait pas).
   */
  function sectionsFetch(ids) {
    return fetch(ROOT + '?sections=' + ids.join(','), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  function replaceSection(id, html) {
    var el = document.getElementById(id);
    if (!el || !html) return;
    var d = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (d) el.innerHTML = d.innerHTML;
  }
  function refreshCartUI(lastKey) {
    var drawer = document.querySelector('cart-drawer');
    var notif = document.querySelector('cart-notification');
    var p;
    if (drawer && typeof drawer.renderContents === 'function') {
      p = sectionsFetch(['cart-drawer', 'cart-icon-bubble']).then(function (sec) {
        if (sec && sec['cart-drawer']) { try { drawer.renderContents({ id: null, sections: sec }); return; } catch (e) {} }
        if (sec) replaceSection('cart-icon-bubble', sec['cart-icon-bubble']);
      });
    } else if (notif && typeof notif.renderContents === 'function' && lastKey) {
      p = sectionsFetch(['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble']).then(function (sec) {
        if (sec && sec['cart-notification-product']) { try { notif.renderContents({ key: lastKey, sections: sec }); return; } catch (e) {} }
        if (sec) replaceSection('cart-icon-bubble', sec['cart-icon-bubble']);
      });
    } else {
      p = sectionsFetch(['cart-icon-bubble']).then(function (sec) { if (sec) replaceSection('cart-icon-bubble', sec['cart-icon-bubble']); });
    }
    fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lz-mc', cartData: c }); } catch (e) {}
        }
      })
      .catch(function () {});
    return p;
  }

  /**
   * items = [{ id: variantId, quantity? }]. src = provenance mesurée (mc-dash,
   * mc-bar, mc-wish, mc-card…). Les lots refusés (une carte vendue entre-temps)
   * sont rejoués carte par carte pour ne pas tout perdre.
   */
  function addToCart(items, src, opts) {
    opts = opts || {};
    var props = src ? { _lz_src: String(src).slice(0, 40) } : null;
    var list = items.map(function (it) {
      var o = { id: Number(it.id), quantity: it.quantity || 1 };
      if (props) o.properties = props;
      return o;
    }).filter(function (o) { return o.id > 0; });
    var added = 0, failed = [], lastKey = null, capped = 0, streak = 0;
    function keyOf(r) {
      var it = r && r.body && (r.body.items || (r.body.key ? [r.body] : null));
      if (it && it.length && it[it.length - 1].key) lastKey = it[it.length - 1].key;
    }
    // Un panier Shopify accepte 500 lignes au plus : pour un ajout groupé, on ne
    // tente que la place restante (le reste serait refusé carte par carte).
    var room = list.length > 25
      ? fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
          .then(function (c) { return Math.max(0, CART_MAX_LINES - ((c && c.items) ? c.items.length : 0)); }, function () { return CART_MAX_LINES; })
      : Promise.resolve(CART_MAX_LINES);
    return room.then(function (free) {
      if (list.length > free) { capped = list.length - free; list = list.slice(0, free); }
      var chunks = [];
      for (var i = 0; i < list.length; i += 25) chunks.push(list.slice(i, i + 25));
      return chunks.reduce(function (pr, chunk) {
        return pr.then(function () {
          return postAdd(chunk).then(function (r) {
            if (r.ok) { added += chunk.length; streak = 0; keyOf(r); return; }
            // Un article indisponible fait échouer tout le lot : on rejoue un par un,
            // en s'arrêtant après 5 refus de suite (panier plein, boutique saturée).
            return chunk.reduce(function (p2, one) {
              return p2.then(function () {
                if (streak >= 5) { failed.push(one.id); return; }
                return postAdd([one]).then(function (r1) {
                  if (r1.ok) { added++; streak = 0; keyOf(r1); } else { failed.push(one.id); streak++; }
                });
              });
            }, Promise.resolve());
          });
        });
      }, Promise.resolve());
    }).then(function () {
      if (added && opts.refresh !== false) refreshCartUI(lastKey);
      if (capped) toast('Panier plein : Shopify accepte 500 lignes au plus. ' + plural(capped, 'carte n’a pas été ajoutée', 'cartes n’ont pas été ajoutées') + '.', 'warn');
      return { added: added, failed: failed, key: lastKey, capped: capped };
    });
  }

  // ---------------------------------------------------------------------------
  // Collection locale (visiteur non connecté) : rien n'est envoyé au serveur
  // tant que la personne ne s'est pas connectée et n'a pas accepté l'import.
  // ---------------------------------------------------------------------------
  var LKEY = 'lzmc:guest:v1';
  var local = {
    // Même stockage que le mode visiteur de lz-api-client.js (une seule source).
    read: function () {
      if (window.lzApi && window.lzApi.guest) return window.lzApi.guest.read();
      try { var o = JSON.parse(localStorage.getItem(LKEY) || '{}'); return o && typeof o === 'object' ? o : {}; } catch (e) { return {}; }
    },
    write: function (o) {
      if (window.lzApi && window.lzApi.guest) return window.lzApi.guest.write(o);
      try { o._at = Date.now(); localStorage.setItem(LKEY, JSON.stringify(o)); } catch (e) {}
    },
    get: function (u) {
      var o = local.read()[u] || {};
      return { products: o.p || {}, variants: o.v || {} };
    },
    /** kind: 'p' (produit) | 'v' (variante). meta = { s: série, t: titre, k: type } */
    set: function (u, kind, id, owned, meta) {
      var o = local.read();
      o[u] = o[u] || { p: {}, v: {} };
      var bag = o[u][kind] = o[u][kind] || {};
      if (owned) bag[String(id)] = meta || {}; else delete bag[String(id)];
      local.write(o);
    },
    count: function () {
      var o = local.read(), n = 0;
      Object.keys(o).forEach(function (u) { if (u.charAt(0) !== '_' && o[u] && o[u].p) n += Object.keys(o[u].p).length; });
      return n;
    },
    clear: function () { try { localStorage.removeItem(LKEY); } catch (e) {} },
  };

  /** Une fois connecté : propose d'envoyer la collection locale sur le compte. */
  function importLocal() {
    var o = local.read();
    var api = window.lzApi;
    if (!api || !api.isLoggedIn()) return Promise.resolve({ imported: 0 });
    var jobs = [], total = 0;
    Object.keys(o).forEach(function (u) {
      if (u.charAt(0) === '_' || !o[u]) return;
      var items = [];
      Object.keys(o[u].p || {}).forEach(function (id) {
        var m = o[u].p[id] || {};
        items.push({ type: 'product', id: id, owned: true, series_handle: m.s || '', product_title: m.t || '' });
      });
      Object.keys(o[u].v || {}).forEach(function (id) {
        var m = o[u].v[id] || {};
        items.push({ type: 'variant', id: id, owned: true, series_handle: m.s || '', product_title: m.t || '', variant_kind: m.k || '' });
      });
      for (var i = 0; i < items.length; i += 400) {
        (function (batch) {
          jobs.push(function () { return api.bulkSet({ universe: u, items: batch }).then(function (r) { if (r && r.ok) total += batch.length; return r; }); });
        })(items.slice(i, i + 400));
      }
      // Progression locale par série : envoyée pour que le tableau de bord la voie tout de suite.
      Object.keys(o[u].g || {}).forEach(function (h) {
        var g = o[u].g[h];
        jobs.push(function () {
          return api.syncProgress({
            universe: u, seriesHandle: h, seriesTitle: g.series_title || '',
            totalCards: g.total_cards, ownedCards: g.owned_cards,
            totalReverseCards: g.total_reverse_cards, ownedReverseCards: g.owned_reverse_cards,
          });
        });
      });
    });
    return jobs.reduce(function (p, j) { return p.then(j); }, Promise.resolve()).then(function () {
      if (total) { local.clear(); track('guest_import', { items: total, source: 'other' }); }
      return { imported: total };
    });
  }

  // ---------------------------------------------------------------------------
  // Mesure et toasts
  // ---------------------------------------------------------------------------
  function track(name, data) {
    var api = window.lzApi;
    if (!api || !api.isLoggedIn || !api.isLoggedIn()) return;
    var p = Object.assign({ name: name }, data || {});
    try { api.track(p); } catch (e) {}
  }

  /** link (optionnel) = { href, label } : lien affiché sous le message. */
  function toast(text, kind, link) {
    var el = document.getElementById('lzmc-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'lzmc-toast';
      el.className = 'lzmc-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.className = 'lzmc-toast is-visible' + (kind ? ' is-' + kind : '') + (link ? ' has-link' : '');
    el.textContent = text;
    if (link && link.href) {
      var a = document.createElement('a');
      a.href = link.href;
      a.textContent = link.label || 'Voir';
      el.appendChild(document.createElement('br'));
      el.appendChild(a);
    }
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { el.className = 'lzmc-toast'; }, link ? 6000 : 2600);
  }

  window.LZMC = {
    version: '2.0.0',
    money: money, esc: esc, plural: plural,
    series: series, dropSeries: cacheDrop,
    primaryVariant: primaryVariant, reverseVariant: reverseVariant,
    missing: missing,
    addToCart: addToCart, refreshCartUI: refreshCartUI,
    local: local, importLocal: importLocal,
    track: track, toast: toast,
    _parse: parseDataHtml, _normalize: normalizeSeries,
  };
  try { document.dispatchEvent(new CustomEvent('lzmc:ready')); } catch (e) {}
})();
